import { render, staticRenderFns } from "./SendViaEmail.vue?vue&type=template&id=a0090962"
import script from "./SendViaEmail.vue?vue&type=script&lang=js"
export * from "./SendViaEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports